module.exports = "subdir test template";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates/subdir/tmpl.js
 ** module id = 12
 ** module chunks = 0
 **/